module.exports = __webpack_public_path__ + "static/img/floatimgV2.f356fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floatimgV2.png
// module id = 7e9k
// module chunks = 1